export const SELF_COMPANY_ID = "SELF_COMPANY_ID";
